/**
 * Estimated one-rep max using the Epley formula: weight × (1 + reps / 30).
 *
 * A single rep is its own 1RM. Zero or negative inputs return 0. Unit-agnostic:
 * the result is in whatever unit `weight` is in.
 */
export function estimateOneRepMax(weight: number, reps: number): number {
  if (weight <= 0 || reps <= 0) return 0;
  if (reps === 1) return weight;
  return weight * (1 + reps / 30);
}
